import React, { useState } from 'react';
import './Meme.css';

const Meme = () => {
  const [email, setEmail] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    // Here you would typically send the email to your backend
    console.log('Email submitted:', email);
    setIsSubmitted(true);
    setEmail('');
  };

  return (
    <div className="meme-container">
      <div className="meme-content">
        <div className="meme-header">
          <h1>UFC Meme Creator</h1>
          <div className="coming-soon-badge">Coming Very Soon!</div>
        </div>
        <hr />
        <div className="meme-text">
          <p>
            Express your passion by creating and sharing the best UFC memes with our community!
          </p>

          <div className="feature-highlight">
            <p><strong>We're currently testing this feature with our first users!</strong></p>
            <p>Our meme creator will allow you to create and share custom memes with our community.</p>
          </div>

          <div className="signup-section">
            <h3>Get Notified When It's Ready!</h3>
            <p>Sing up today to get notified when the UFC Meme Creator is ready.</p>
            <a href="/auth" className="signup-btn">Sign Up Now</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Meme; 